import * as DateF from 'date-fns';
import { Duration } from '@blade/std-lib';
export const formatDurationShort = (interval, timeUnits, defaultFormat) => {
    const duration = DateF.intervalToDuration({
        start: 0,
        end: Duration.toMillis(interval),
    });
    const format = defaultFormat ?? [
        'years',
        'months',
        'weeks',
        'days',
        'hours',
        'minutes',
        'seconds',
    ];
    // `date-fns` doesn't compute `weeks` in `intervalToDuration` (it returns `days` instead).
    // We derive `weeks` from `days` when weeks are requested in format.
    const durationNormalized = (() => {
        if (!format.includes('weeks')) {
            return duration;
        }
        const days = duration.days ?? 0;
        if (days < 7) {
            return duration;
        }
        const weeks = Math.floor(days / 7);
        const restDays = days % 7;
        return {
            ...duration,
            weeks,
            days: restDays,
        };
    })();
    const formatDistanceLocale = {
        lessThanXSeconds: timeUnits.seconds,
        xSeconds: timeUnits.seconds,
        halfAMinute: timeUnits.minutes,
        lessThanXMinutes: timeUnits.minutes,
        xMinutes: timeUnits.minutes,
        aboutXHours: timeUnits.hours,
        xHours: timeUnits.hours,
        xDays: timeUnits.days,
        aboutXWeeks: timeUnits.weeks,
        xWeeks: timeUnits.weeks,
        aboutXMonths: timeUnits.months,
        xMonths: timeUnits.months,
        aboutXYears: timeUnits.years,
        xYears: timeUnits.years,
        overXYears: timeUnits.years,
        almostXYears: timeUnits.years,
    };
    const shortLocale = {
        formatDistance: (token, count) => formatDistanceLocale[token].replace('{{count}}', count.toString()),
    };
    return DateF.formatDuration(durationNormalized, {
        format,
        locale: shortLocale,
    });
};
export const Unit = {
    Years: 'years',
    Months: 'months',
    Weeks: 'weeks',
    Days: 'days',
    Hours: 'hours',
    Minutes: 'minutes',
    Seconds: 'seconds',
};
const UNITS = [
    Unit.Years,
    Unit.Months,
    Unit.Weeks,
    Unit.Days,
    Unit.Hours,
    Unit.Minutes,
    Unit.Seconds,
];
/**
 * Returns the largest unit in duration
 */
export const getLargestDurationUnit = (duration) => {
    return UNITS.find((unit) => duration[unit] && duration[unit] > 0);
};
/**
 * Formats duration and keeps single unit
 */
export const formatDurationSingleUnit = (duration, options) => {
    const processUnit = (unit) => {
        if (duration[unit] && duration[unit] > 0) {
            return DateF.formatDuration(duration, { format: [unit], ...options });
        }
        return undefined;
    };
    for (const unit of UNITS) {
        const result = processUnit(unit);
        if (result) {
            return result;
        }
    }
    return undefined;
};
//# sourceMappingURL=duration-formatter.js.map